module.exports = __webpack_public_path__ + "img/other.ce019b21.jpg";